import React from 'react';
import styled, { withTheme } from 'styled-components';
import { Link } from "react-router-dom";
import { ifProp, theme, withProp } from 'styled-tools';
// images
// import DiscoverBBBEdge from "../../images/discover_the_edge_bg.png";
// import DiscoverBottom from "../../images/discover_the_edge_bg.png";
// import FirstCarousel from "../../images/BBB Edge.jpg";
import config from 'src/config/config';
import Intl from '../common/Intl'
import { withAppContext } from 'src/store/initAppContext';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import PlaceholderImage from 'src/components/Placeholder';

const BBBEdge = (props) => {
    const { theme, app: { brandId } } = props

    const getWhitelableName = (brandId) => {
        switch (brandId) {
            case 31: return 'TITLE@DISCOVER_BBBEDGE'
                break;
            case 32: return 'TITLE@DISCOVER_BBBEDGE'
                break;
            case 33: return 'TITLE@BETDAILYEDGE'
                break;
            case 34: return 'TITLE@BETDAILYEDGE'
                break;
            case 39: return 'TITLE@FOMOEDGE'
                break;
            case 40: return 'TITLE@FOMOEDGE'
                break;
            case 46: return 'TITLE@FUN88EDGE'
                break;
            case 47: return 'TITLE@FUN88EDGE'
                break;

            default: return 'EXPLORE OUR NEW PLATFORM'
        }
    }
    return (
        <MainWrapper>
            <Wrapper1>
                <h3><Intl langKey={getWhitelableName(brandId)} /></h3>
            </Wrapper1>

            <Wrapper2>
                <SubWrap> <LazyLoadImage src={`${config.imageS3Host}/static/snk/${theme.image.new_whitelable_home_discover_the_edge}`} effect="none" height="100%" width="100%" placeholder={<PlaceholderImage />} /></SubWrap>
                <div className="butto">
                    {/* {
                        (brandId == 33 || brandId == 34 || brandId == 31 || brandId == 32 || brandId == 39 || brandId == 40) && (
                            <>
                                <Link to='/betting-exchange'><Button1><Intl langKey="TITLE@EXPLORE_NOW" /></Button1></Link>
                                <Link to='/live-casino'> <Button1><Intl langKey="TITLE@EXPLORE_NOW" /></Button1></Link>
                            </>
                        )
                    } */}
                    <Link to='/betting-exchange'><Button1><Intl langKey="TITLE@EXPLORE_NOW" /></Button1></Link>
                    <Link to='/live-casino'> <Button1><Intl langKey="TITLE@EXPLORE_NOW" /></Button1></Link>
                </div>
            </Wrapper2>
        </MainWrapper>
    )

}

export default withTheme(withAppContext(BBBEdge));
const MainWrapper = styled.div`
    width: 100%;
`;

const Wrapper1 = styled.div`
    width: 100%;
    /* height: 79px; */
    height: ${theme('palette.discoverEdgeHomePageTittleHeight')};
    padding-bottom: 1px;
    padding-top: ${theme('palette.discoverEdgeHomePageTittlePaddingTop')};
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    /* background-image: url(${config.imageV3Host}/static/cashsite/${theme('image.new_whitelable_separator_v2_homepage')}); */
    background-image: url(${config.imageV3Host}/static/cashsite/${theme('image.discoverTheEdgeNew')});
    background-size: cover;
    background-repeat: no-repeat;
    /* background-position: center; */

    h3 {
        display: flex;
        color: ${theme('palette.homeTittleTexts')};
        text-transform: uppercase;
        font-size: 30px;
        letter-spacing: 0.05em;
        margin: 0;
        line-height: 35px;
        padding-left: 10px;

        @media only screen and (min-width: 1800px){
            font-size: 35px;
        }
    }
`;

const Wrapper2 = styled.div`
   margin:0px;
   padding:0px;
   width: 100%;
   display: flex;
   justify-content: center;
   align-items: center;
   position: relative;

    img {
        width:100%;
        display: flex;
    }

  .butto {
    position: absolute;
    display: flex;
    justify-content: space-between;
    width: 65%;
    top: 54%;
  }
`;

const SubWrap = styled.div`
    display: flex;
    width:100%;

`;
const Button1 = styled.div`
    color: ${theme('palette.loyaltyHomeComponentKnowMoreBtnColor')};
    padding: 10px 0px;
    /* background: ${theme('palette.primary-background-color-linear-new')}; */
    background: ${theme('palette.discoverTheEdgeExploreNwBtn')};
    border-radius: 25px;
    width: 180px;
    font-weight: 600;
    letter-spacing: 1px;
    word-spacing: 3px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: normal;
    border: ${theme('palette.homeExploreBtnBorder')};
    text-transform: uppercase;

    :hover {
        color: ${theme('palette.exploreHOver')};
        background: ${theme('palette.homeTable-background1')};
        transition: all 0.3s ease;
    }
`;
